export const ROUTES = {
  HOME: '/',

  LOGIN: '/login',
  LOGOUT: '/logout',
  RECOVER: '/recover',
  CHANGE_PASSWORD: '/password/reset/:email/:token',

  INVENTORY: '/inventory',
  CONTACTS: '/contacts',
  ACCOUNTS: '/accounts',
  ACCOUNT: '/account',
  PROFILE: '/profile',
  API_KEYS: '/api-keys',
  USERS: '/users',
  MAKES: '/makes',
  VEHICLE: '/vehicle/:vehicleId/:isNew?',
  DEALS: '/deals',
  NEW_DEAL: '/new-deal/:vehicleId?',
  EDIT_DEAL: '/deal/edit/:dealId',
  VIEW_DEAL: '/deal/view/:dealId',
  ANALYTICS: '/analytics',
  REPORTS: '/deals-reports',
  COSTS: '/costs',
  DEAL_PRODUCTS: '/deal-products',
};
